module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-3-8d71c013df2d1768aa93f26f06b948e3.webp";